import { Coordinates, FOV, Label, TypedAttributeValue, createTypedAttribute, findTypedAttribute } from '@shared';
import { z } from 'zod';

export const DeduplicationPair = createTypedAttribute(
    'DeduplicationPair',
    z.object({
        camera_left: z.object({
            location: Coordinates.Value,
            fov: FOV.Value,
        }),
        camera_right: z.object({
            location: Coordinates.Value,
            fov: FOV.Value,
        }),
    }),
    ({ camera_left, camera_right }) => `Deduplication: ${camera_left.location.lat}, ${camera_left.location.lon} vs ${camera_right.location.lat}, ${camera_right.location.lon}`,
);

export type DeduplicationPair = TypedAttributeValue<typeof DeduplicationPair>;

export type DeduplicationPairLabel = z.infer<typeof DeduplicationPairLabel>;
export const DeduplicationPairLabel = Label.extend({
    name: z.literal('deduplication_pair'),
    type: z.literal('tag'),
}).transform((label, ctx) => {
    const pairData = findTypedAttribute(label.attributes, 'pair_data', DeduplicationPair);

    if (!pairData.success) {
        pairData.error.issues.forEach(ctx.addIssue);
        return z.NEVER;
    }

    return { ...label, types: { pair_data: pairData.data } };
});

